//SAF-17154 Contains individual routes for the IB depending on the role of the User.
import React from 'react';
import { Route } from 'react-router-dom';
import loadableModule from 'spark-views/main/loadableModule';
import { paths } from './ibNotificationsRoutes.js';

const IBRecipientHome = loadableModule(() =>
    import('./index')
);

const IBRoute = () => (
	<React.Fragment>
		<Route path={paths.root} component={IBRecipientHome} />{/*IB recipient route for recipient */}
	</React.Fragment>
);

export default IBRoute;